import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import messages from '../messages';
import style from '../style.module.less';
import { EMPTY_CONFIRMATION_ID } from '../../../../constants/services';
import { defaultInternationalConfirmation, defaultConfirmation } from '../formattedMessageConstants';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

const PresetGroupConfirmationDropdown = ({
  selectedConfirmationName = '',
  confirmations,
  onConfirmationChanged,
  isEnabled = false,
  isInternational = false,
}) => {
  const intl = useIntl();
  const defaultConfirmationText = isInternational ? defaultInternationalConfirmation : defaultConfirmation;
  const id = isInternational ? 'international-confirmation' : 'domestic-confirmation';
  return (
    <DropdownMenu
      ariaLabel={id}
      data-testid={id}
      disabled={!isEnabled}
      dropdownMenuShouldHaveWidthOfButton
      dropdownMenuType={DropdownMenuType.ComboBox}
      fullWidth
      id={id}
      title={selectedConfirmationName}
      variant='form'
    >
      <DropdownMenuToggler className={style['dropdown-picker']}>{selectedConfirmationName || defaultConfirmationText}</DropdownMenuToggler>
      <DropdownMenuItem onClick={() => onConfirmationChanged(EMPTY_CONFIRMATION_ID)}>
        {intl.formatMessage(messages.confirmationNoneOption)}
      </DropdownMenuItem>
      {confirmations.map(({ confirmationId, name }) => (
        <DropdownMenuItem key={confirmationId} onClick={() => onConfirmationChanged(confirmationId)}>
          {name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

PresetGroupConfirmationDropdown.propTypes = {
  selectedConfirmationName: PropTypes.string,
  confirmations: PropTypes.array.isRequired,
  isEnabled: PropTypes.bool,
  onConfirmationChanged: PropTypes.func.isRequired,
  isInternational: PropTypes.bool,
};

export default PresetGroupConfirmationDropdown;
